import * as swcHelpers from '@swc/helpers';
import * as React from 'react';

const ReactDatePicker = (_param)=>{
    var { locale , dateFnsLocale  } = _param, props = swcHelpers.objectWithoutProperties(_param, [
        "locale",
        "dateFnsLocale"
    ]);
    const [Module, setModule] = React.useState(null);
    const loadComponent = React.useCallback(swcHelpers.asyncToGenerator(function*() {
        const importedModule = yield import(/* webpackChunkName: 'react-datepicker' */ 'react-datepicker');
        const { registerLocale  } = importedModule;
        registerLocale(locale, dateFnsLocale);
        setModule(importedModule);
    }), [
        locale,
        dateFnsLocale
    ]);
    React.useEffect(()=>{
        loadComponent();
    }, [
        loadComponent
    ]);
    // Don't render if we didn't register the (date-fns)locale correctly
    // as we're not able to translate days/months without it
    return Module && /*#__PURE__*/ React.createElement(Module.default, swcHelpers.extends({
        locale: locale
    }, props));
};

export { ReactDatePicker as default };
//# sourceMappingURL=ReactDatePicker.js.map
